<template>
  <div>
    <!--список предыдущих заказов-->
    <div v-if="loading" style="border: 1px solid #F0F0F0"><v-progress-circular :width="2" indeterminate style="color: forestgreen"/></div>
    <div v-else>
      <div class="uk-margin-small uk-text-bold uk-text-muted">
       {{local_page_keys.title_previous_orders}}:
      </div>
      <!--Отображаем предыдущих 15 заказов-->
      <div v-if="empty_prev_orders_block === ''" :class="dataGridCol" class="prev_block uk-grid tm-grid-xsmall" data-uk-grid>
        <div v-for="(order,index) of prev_orders_block" :key="index" class="prev_item_">
          <div class="tm-order-prev-img uk-flex uk-flex-middle uk-flex-center uk-transition-toggle uk-position-relative uk-text-center uk-text-small">
            <div  class="uk-position-relative">
              <img v-if="order.little_photo_before" :src="order.little_photo_before" alt="" v-on:error="setFallbackImage()">
              <img v-else-if="order.little_photo_after" :src="order.little_photo_after" alt="" v-on:error="setFallbackImage()">
              <img v-else src="/img/images.png" alt="">
            </div>
            <a href="javascript: void(0);" @click="showOrder(order,'prevBlock',index)" class="uk-transition-fade uk-position-cover uk-overlay-primary uk-flex uk-flex-center uk-flex-middle">
              <md-icon class="md-size-2x tm-light">zoom_in</md-icon>
            </a>
          </div>
          <div v-if="order.like_by_client" class="tm-order-prev-likes tm-text-small uk-text-center">
            <span class="likes-gold">{{ "★".repeat(order.like_by_client['value']) }}</span>
            <span class="likes-grey">{{ "★".repeat(5-order.like_by_client['value']) }}</span>
          </div>
        </div>
      </div>
      <div v-else>{{ empty_prev_orders_block }}</div>
      <hr class="uk-margin-small">
      <!--Отображаем следующие 15 заказов-->
      <div class="uk-margin-small uk-text-bold uk-text-muted">
        {{ local_page_keys.label_next_orders }}:
      </div>
      <div v-if="empty_next_orders_block === ''" :class="dataGridCol" class="prev_block uk-grid tm-grid-xsmall">
        <div v-for="(order,index) of next_orders_block" :key="index" class="prev_item_">
          <div class="tm-order-prev-img uk-flex uk-flex-middle uk-flex-center uk-transition-toggle uk-position-relative uk-text-center uk-text-small">
            <div  class="uk-position-relative">
              <img v-if="order.little_photo_before" :src="order.little_photo_before" alt="" v-on:error="setFallbackImage()">
              <img v-else-if="order.little_photo_after" :src="order.little_photo_after" alt="" v-on:error="setFallbackImage()">
              <img v-else src="/img/images.png" alt="">
            </div>
            <a href="javascript: void(0);" @click="showOrder(order,'nextBlock',index)" class="uk-transition-fade uk-position-cover uk-overlay-primary uk-flex uk-flex-center uk-flex-middle">
              <md-icon class="md-size-2x tm-light">zoom_in</md-icon>
            </a>
          </div>
          <div v-if="order.like_by_client" class="tm-chat-box-mess likes tm-text-small uk-margin-small-top uk-text-center">
            <span class="likes-gold">{{ "★".repeat(order.like_by_client['value']) }}</span>
            <span class="likes-grey">{{ "★".repeat(5 - order.like_by_client['value']) }}</span>
          </div>
        </div>
      </div>
      <div v-else>{{ empty_next_orders_block }}</div>
    </div>
    <FunctionInfoDialog
      :name="info.name"
      :text="info.text"
      :video="info.video"
      :show="showDialog"
      :items="info.items"
      :prevOrderBlock="true"
      :function_name = "info.function_name"
      :showDialogFaceValue="computedFaceValue"
      @hide="showDialog = false; showDialog7 = true"/>
    <!--диалоговое окно "Галерея примеров"-->
    <FunctionGalleryDialog
      :currentIndex="currentExampleCarouselIndex"
      :parent_function_name="info_function_name"
      :show="showDialog6"
      :items="info.items"
      :prevOrderBlock="true"
      :showDialogFaceValue="computedFaceValue"
      @hide="showDialog6 = false"
      @catchOnHidePrev="handleHideEvent"/>
    <!--диалоговое окно для предыдущих выполненных заказов-->
    <div v-if="showDialog7" style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast tm-prev-next-modal" @blur="closeModal">
      <div class="uk-modal-dialog" v-click-outside="closeModal">
        <!--кнопка закрытия модалки-->
        <button class="uk-close uk-close-large uk-modal-close-outside" type="button" data-uk-close @click="closeModal()"></button>
        <div class="uk-modal-body">
          <div class="uk-position-relative">
            <div class="uk-grid" data-uk-grid>
              <preloader :is-visible="loadingOrder"/>
              <!--левая часть-->
              <div class="uk-width-auto">
                <photo-block-with-zoom
                  :zoneVisible="zoneVisible"
                  :zone_photo="zone_photo"
                  :afterVisible="afterVisible"
                  :isOutChat="isOutChat"
                  :main_photo_after="modal_photo_after"
                  :main_photo_before="modal_photo_before"
                  :orderId="Number(order_id)"
                  :fullImageList="fullImageList"/>
              </div>
              <!--правая часть-->
              <div class="uk-width-expand" v-if="faces">
                <!--Описание фукнций-->
                <div class="uk-padding-xsmall tm-background-muted 2">
                  <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                    <div v-if="Object.keys(facesOrderSuperFunction).length > 0">
                      <img class="tm-img-icon" :src="facesOrderSuperFunction.icon" width="30" height="30" alt="">
                    </div>
                    <div>
                      {{ local_page_keys.label_ordering_instructions }}:
                    </div>
                  </div>
                </div>
                <!--список функций, сделанные в заказе-->
                <div>
                  <!--список-->
                  <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-info-list uk-text-small" data-uk-grid>
                    <!--общее-->
                    <div v-for="(face, key) in faces" :key="key+'_modal'">
                      <div class="uk-padding-small" v-if="key === 0">{{ local_page_keys.label_instructions_general }}</div>
                      <div class="uk-padding-small" v-else-if="getFaceInfo(key).deleted_at === null">
                        <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                          <div v-html="getFaceName(key)"></div>
                          <div>
                            <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">
                          </div>
                        </div>
                      </div>
                      <!--Список фукнции-->
                      <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1" v-for="(orderFunction, index, name) in face" :key="key+name" data-uk-grid>
                        <!--элемент-->
                        <div v-if="(index != 'order_super_function' && index != 'order_silver_super_function' && index != 'order_subscription_super_function')  || (!orderFunction.hasOwnProperty('deleted') && orderFunction.deleted === false)">
                          <div>
                            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle" data-uk-height-match="target: > div > div" data-uk-grid>
                              <!--1 - иконка-->
                              <div class="uk-width-auto">
                                <div class="uk-padding-xxsmall uk-flex uk-flex-middle">
                                  <div class="uk-width-1-1">
                                    <img v-if="orderFunction.icon" class="tm-img-icon" :src="orderFunction.icon" width="30" height="30" alt="">
                                    <img v-else class="tm-img-icon" src="/img/images.png" width="30" height="30" alt="">
                                  </div>
                                </div>
                              </div>
                              <!--2 - статусы-->
                              <div class="uk-width-2-5" style="line-height: 1.2;">
                                <div class="uk-padding-xxsmall uk-flex uk-flex-middle">
                                  <div class="uk-width-1-1">
                                    <div v-if="orderFunction.capacity" class="tm-status" :class="orderFunction.capacity_color ? orderFunction.capacity_color : 'tm-status-custom'">
                                      {{ orderFunction.capacity }}
                                    </div>
                                    <div v-if="!orderFunction.capacity && orderFunction.text">{{ orderFunction.text }}
                                      <span class="material-icons" style="cursor: pointer" v-if="orderFunction.text && orderFunction.text.length > 0" @click="openGoogleTranslate(orderFunction.text)">translate</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--3 - функция-->
                              <div class="uk-width-expand" style="line-height: 1.2;">
                                <div class="uk-padding-xxsmall uk-flex uk-flex-middle">
                                  <div class="uk-width-1-1">
                                    <div v-if="orderFunction.RU">{{ orderFunction.RU }}</div>
                                    <div v-else>{{ orderFunction.name }}</div>
                                  </div>
                                </div>
                              </div>
                              <!--4 - инфо-->
                              <div class="uk-width-auto">
                                <div class="uk-padding-small uk-text-center uk-flex uk-flex-middle">
                                  <div class="uk-width-1-1">
                                    <a href="#" class="md-simple" @click="infoDialog(orderFunction)">
                                      <span class="material-icons">feedback</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div @mouseleave="isOutChat = true" @mousemove="isOutChat = false">
                      <ChatBlock
                        :infoloading="infoloading"
                        v-if="order_chat !== '' && user"
                        :order_chat="!Array.isArray(order_chat) ? Object.values(order_chat) : order_chat"
                        :faces="faces"
                        :order_id="Number (order_id)"
                        :user="user.email"
                        :role="user.role"
                        @zone-visible="zoneVisible = $event"
                        @after-visible="afterVisible = $event"
                        @zone_photo="zone_photo = $event"
                        @loading="infoloading = $event"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--кнопка предыдущего заказа-->
          <div class="uk-position-center-left-out uk-padding">
            <a
              href="#"
              :disabled="activeOrderKey[currentType] && activeOrderKey[currentType] <= 0"
              @click="prevOrder"
              class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
              data-uk-slidenav-previous>
            </a>
          </div>
          <!--кнопка следующего заказа-->
          <div class="uk-position-center-right-out uk-padding">
            <a
              href="#"
              :disabled="activeOrderKey[currentType] && activeOrderKey[currentType] >= (activeOrders[currentType].length-1)"
              @click="nextOrder"
              class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
              data-uk-slidenav-next>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FunctionInfoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDialog";
import FunctionGalleryDialog from "@/pages/Dashboard/Components/Dialogs/FunctionGalleryDialog";
import LangMixin from "@/mixins/lang-mixin";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";
import PhotoBlockWithZoom from "@/pages/Dashboard/Components/PhotoBlockWithZoom";
import Preloader from "@/pages/Dashboard/Components/Preloader";
export default {
  name: "PrevOrdersBlock",
  props: {
    currRole: {
      type: String,
      require: false
    },
    dataGridCol:{
      type: String,
      default: 'tm-child-width-1-15'
    },
  },
  mixins: [LangMixin],
  components: {FunctionInfoDialog,FunctionGalleryDialog,ChatBlock,PhotoBlockWithZoom, Preloader,},
  data: () => ({
    infoloading:true,
    loading: true,
    loadingOrder: false,
    prev_orders_block: null,
    next_orders_block: null,
    currentType: null,
    showDialog7: false,
    showDialog: false,
    info: {
      name: '',
      text: '',
      video: '',
      items: [],
      function_name: ''
    },
    showDialog6: false,
    showDialogFaceValue:{},
    items: [
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
    ],
    currentExampleCarouselIndex: 0,
    info_function_name: "",
    empty_prev_orders_block: '',
    empty_next_orders_block: '',
    modal_photo_after: null,
    modal_photo_before: null,
    role: '',
    faces: [],
    local_page_keys: {},
    baseUrl: '',
    user: '',
    getterKey:0,
    order_id: '',
    order_chat: '',
    description: 'before',
    fullImageList: {},
    zoneVisible: false,
    zone_photo: null,
    afterVisible: true,
    isOutChat: true,
    activeOrders: {},
    activeOrderKey: {},
    facesInfo: [],
    facesOrderSuperFunction: {},
  }),
  methods: {
    getFaceName(value) {
      return value > 0 ? this.local_page_keys.label_instructions_face + ' ' + value + ':' : this.local_page_keys.common;
    },
    getFaceInfo(face) {
      let faceInfo = this.facesInfo.find(element => element.face === String(face));
      if(typeof faceInfo != 'undefined' && 'deleted_at' in faceInfo){
        return faceInfo;
      } else {
        return {deleted_at:null};
      }
     //return this.facesInfo.find(element => element.face === String(face))
    },
    getOrderSuperFunction() {
      let filterKey;
      let filterName;
      const facesObjFiltered = Object.fromEntries(
          Object.entries(this.faces).filter(([key, value]) => {
                let filtered = {};
                ['order_super_function', 'order_silver_super_function', 'order_subscription_super_function'].forEach(function (name) {
                  if (value.hasOwnProperty(name)) {
                    filterKey = key;
                    filterName = name;
                    filtered = value[name];
                  }
                });
                return Object.keys(filtered).length > 0;
              }
          ));
      if (filterKey in facesObjFiltered && filterName in facesObjFiltered[filterKey]) {
        this.facesOrderSuperFunction = facesObjFiltered[filterKey][filterName];
      }
    },

    closeModal() {
      document.documentElement.classList.remove('uk-modal-page');
      this.showDialog7 = false;
      this.$emit('hide', {showDialog7:false});
      document.documentElement.classList.remove('uk-modal-page');
    },
    handleHideEvent(payload){
      if ('parent_function_obj' in payload && payload.parent_function_obj
          &&  Object.keys( payload.parent_function_obj).length > 0) {
        this.infoDialog( payload.parent_function_obj)
      }
    },

    async fetchPrevOrdersBlock() {
      try {
        if (this.role === 'test-retoucher' && this.currRole) {
          await this.$store.dispatch("order/prevOrdersBlock", this.currRole);
        } else {
          await this.$store.dispatch("order/prevOrdersBlock");
        }
        let data = await this.$store.getters['order/prevOrdersBlock'];
        if (data) {
          if (typeof (data.prev_orders_block) !== 'string') {
            this.prev_orders_block = data.prev_orders_block;
            this.loading = false;
          } else {
            this.empty_prev_orders_block = data.prev_orders_block;
            this.loading = false;
          }
          if (typeof (data.next_orders_block) !== 'string') {
            this.next_orders_block = data.next_orders_block;
            this.loading = false;
          } else {
            this.empty_next_orders_block = data.next_orders_block;
            this.loading = false;
          }

          if (this.prev_orders_block) {
            this.activeOrders['prevBlock'] = this.prev_orders_block.map((order) => order.order_id ?? null);
          }
          if (this.next_orders_block) {
            this.activeOrders['nextBlock'] = this.next_orders_block.map((order) => order.order_id ?? null);
          }

        } else {
          this.errors = 'Failed historyBlock';
          this.loading = false;
        }

      } catch (e) {
        alert(e);
      }
    },
    async showOrder(data,type,index) {
      this.loadingOrder = true;
      this.currentType = type;
      this.faces = [];
      this.order_chat = '';
      this.showDialog7 = true;
      this.modal_photo_after = data.modal_photo_after;
      this.modal_photo_before = data.modal_photo_before;
      this.fullImageList = data.order_photo_file_list;
      this.activeOrderKey[type] = index;
      if (data.order_id) {
        await this.fetchChatBlock(data.order_id);
        await this.$store.dispatch("order/orderFunctionsBlock", {'order_id': data.order_id});
        let result = this.$store.getters['order/orderFunctionsBlock'];
        this.faces = result && 'order_functions' in result ? result.order_functions : [];
        this.faces_info = result && 'faces_info' in result ? result.faces_info : [];
        this.order_id = data.order_id;
        this.getOrderSuperFunction();

      }
      this.loadingOrder = false;
    },
    async nextOrder() {
      let index = this.activeOrderKey[this.currentType] + 1;
      if (this.activeOrders[this.currentType][index]) {
        let order = null;
        if (this.currentType === 'prevBlock') {
          order = this.prev_orders_block[index]
        } else if (this.currentType === 'nextBlock') {
          order = this.next_orders_block[index]
        }
        if (order)
          await this.showOrder(order,this.currentType,index);
      }

    },
     async prevOrder() {
      let index = this.activeOrderKey[this.currentType] - 1;
      if (this.activeOrders[this.currentType][index]) {
        let order = null;
        if (this.currentType === 'prevBlock') {
          order = this.prev_orders_block[index]
        } else if (this.currentType === 'nextBlock') {
          order = this.next_orders_block[index]
        }
        if (order)
          await this.showOrder(order,this.currentType,index);
      }
    },
    async fetchChatBlock(order_id) {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", order_id);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    async getPageLocalization() {
      this.local_page_keys = await this.$filtergetLocalisationPages(['order','order-infoBlock']);
    },
    infoDialog(faceValue) {
      this.$nextTick( () => {
        this.showDialogFaceValue = faceValue;
        this.info.name = faceValue.RU;
        this.info.function_name = faceValue.name;
        this.info.text = faceValue.instruction_text;
        this.info.video = faceValue.video;
        this.info.items = faceValue.links;
        this.showDialog7 = false;
        this.showDialog = true;
      });
    },
    setFallbackImage() {
      event.target.src =  "/img/images.png";
    }
  },
  computed:{
    computedFaceValue(){
      return this.showDialogFaceValue;
    },
  },
  watch: {
    showDialog7: {
      handler(v) {
          if (v) {
            document.documentElement.classList.add('uk-modal-page');
            setTimeout(function(){
                if(!document.documentElement.classList.contains('uk-modal-page')){
                  document.documentElement.classList.add('uk-modal-page');
                }
            }, 800)
          } else {
            document.documentElement.classList.remove('uk-modal-page');
          }

      }
    },
  },
  async created() {
    this.role = this.$store.getters['profile/role'];
    this.baseUrl = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    await this.fetchPrevOrdersBlock();
    await this.getPageLocalization();
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    if(document.documentElement.classList.contains('uk-modal-page')){
      document.documentElement.classList.remove('uk-modal-page');
    }
  },
}
</script>
<style>
  .tm-prev-next-modal > div {
    width: 100%;
  }
  .tm-order-check .tm-prev-next-modal .tm-block-img,
  .tm-prev-next-modal .tm-block-img {
    height: 750px !important;
    width: 600px !important;
  }
  .tm-order-check .tm-prev-next-modal .tm-block-img .iiz picture,
  .tm-prev-next-modal .tm-block-img .iiz picture {
    height: 750px !important;
  }
  .tm-order-check .tm-prev-next-modal .tm-block-img img:not(.iiz__zoom-img--visible),
  .tm-prev-next-modal .tm-block-img img:not(.iiz__zoom-img--visible) {
    max-height: 750px !important;
  }

  @media (min-width: 960px) {
    .tm-prev-next-modal > div {
      width: 83%;
    }
  }
  .tm-check-dialog > div {
    overflow: visible !important;
  }
  .uk-transition-toggle {
    -webkit-tap-highlight-color: transparent;
  }
</style>